import { render, staticRenderFns } from "./diretos.vue?vue&type=template&id=ba4e5be8"
import script from "./diretos.vue?vue&type=script&lang=js"
export * from "./diretos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports